import Cookies from 'js-cookie'
import moment from 'moment-timezone'

export const createSessionId = () => `session_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`

export const createInitialState = () => ({
  loading: false,
  isLoggingOut: false,
  sessionId: createSessionId(),
  token: Cookies.get('access') ?? null,
  needUpdate: false,
  internetConnection: {
    checking: false,
    stable: true,
    dismissed: false,
    lastCheckedAt: null
  },
  user: null,
  associate: null,
  responsibleContacts: {},
  currentProject: null,
  currentPaymentType: null,
  currentPaymentTypeName: null,
  allProjects: null,
  timeCardsSelectedEmployee: undefined,
  shiftAuthSelectedEmployee: undefined,
  timeZone: moment.tz.guess(),
  dateFormat: 'MM/DD/YYYY',
  dateTimeFormat: 'MM/DD/YYYY hh:mm A',
  serverDateFormat: 'YYYY-MM-DD',
  timeFormat: 'hh:mm A',
  extendedShiftAuthTypes: [],
  timeConstants: {},
  projectRoles: [],
  projectDepartments: [],
  projectLegalEntities: [],
  projectPaymentSystems: [],
  projectPayCodes: [],
  workAreas: [],
  reports: [],
  scheduleTypes: [
    {
      id: 4,
      name: 'free',
      label: 'Free'
    },
    {
      id: 1,
      name: 'fixed',
      label: 'Strict'
    },
    {
      id: 3,
      name: 'self_schedule',
      label: 'Flexible'
    }
  ],
  paymentTypes: [
    {
      id: 6,
      name: 'Contractor'
    },
    {
      id: 3,
      name: 'Employee'
    },
    {
      id: 5,
      name: 'Volunteer'
    }
  ],
  chartOptions: {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1
        }
      }
    },
    plugins: {
      legend: {
        display: false
      }
    }
  }
})

export default createInitialState()
